import { FC } from 'react';

import { Card, Divider, FullPageContainer, Table, useBreakpoint, VSpacingContainer } from '@hh.ru/magritte-ui';

import { PromoCodeTableContent } from 'components/Admin/PromoCodes/PromoCodesTable/PromoCodeTableContent';
import { PromoCodeTableHeader } from 'components/Admin/PromoCodes/PromoCodesTable/PromoCodeTableHeader';

export const PromoCodes: FC = () => {
    const { isMobile } = useBreakpoint();

    return (
        <FullPageContainer>
            {({ paddingLeft, paddingRight }) => {
                return (
                    <Card stretched>
                        {isMobile ? (
                            <VSpacingContainer default={12}>
                                <PromoCodeTableHeader />
                                <Divider />
                                <PromoCodeTableContent />
                            </VSpacingContainer>
                        ) : (
                            <Table divider paddingLeft={paddingLeft} paddingRight={paddingRight} density={24}>
                                <PromoCodeTableHeader />
                                <PromoCodeTableContent />
                            </Table>
                        )}
                    </Card>
                );
            }}
        </FullPageContainer>
    );
};
